import { render, staticRenderFns } from "./delivery_mode_list.vue?vue&type=template&id=7e1084fb"
import script from "./delivery_mode_list.vue?vue&type=script&lang=js"
export * from "./delivery_mode_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports